/** Tâches : listes + tâches (cocher, échéance, notes). */
import { el, clear } from '../ui/dom.js';
import { icon } from '../ui/icons.js';
import { Tasks } from '../api.js';
import { toast } from '../ui/toast.js';
import { contextMenu, confirmModal } from '../ui/modal.js';

export function renderTasks(ctx) {
  const { content } = ctx;
  ctx.setCrumbs([{ label: 'Tâches' }]);

  const cols = el('div', { class: 'tasks-cols' });
  const addListBtn = el('button', { class: 'btn glass', style: { height: 'auto', alignSelf: 'flex-start', padding: '14px 18px' }, html: icon('plus', 18) + 'Nouvelle liste' });
  addListBtn.addEventListener('click', async () => { try { await Tasks.newList('Nouvelle liste'); load(); } catch (e) { toast(e.message, 'err'); } });
  content.append(el('div', { class: 'toolbar' }, el('h2', {}, 'Tâches')), cols);

  async function load() {
    let data;
    try { data = await Tasks.all(); } catch (e) { toast(e.message, 'err'); return; }
    clear(cols);
    data.lists.forEach((list) => cols.appendChild(listPanel(list)));
    cols.appendChild(addListBtn);
  }

  function listPanel(list) {
    const panel = el('div', { class: 'task-list glass' });
    const name = el('input', { value: list.name });
    name.addEventListener('change', () => Tasks.renameList(list.id, name.value).catch(() => {}));
    const menu = el('button', { class: 'btn btn-sm btn-icon btn-ghost', html: icon('more', 16) });
    menu.addEventListener('click', (e) => {
      const r = e.currentTarget.getBoundingClientRect();
      contextMenu(r.left, r.bottom + 4, [
        { label: 'Supprimer la liste', icon: 'trash', danger: true, onClick: async () => {
          if (await confirmModal({ title: 'Supprimer la liste ?', message: 'Les tâches qu’elle contient seront supprimées.', confirm: 'Supprimer', danger: true })) { await Tasks.removeList(list.id); load(); } } },
      ]);
    });
    panel.append(el('div', { class: 'tl-head' }, name, menu));

    const tasksWrap = el('div', {});
    list.tasks.forEach((t) => tasksWrap.appendChild(taskRow(t)));
    panel.appendChild(tasksWrap);

    // add task
    const input = el('input', { placeholder: 'Ajouter une tâche…' });
    const addRow = el('div', { class: 'task-add' }, el('span', { html: icon('plus', 16) }), input);
    const add = async () => {
      const title = input.value.trim(); if (!title) return;
      try { const { task } = await Tasks.create({ list_id: list.id, title }); input.value = ''; tasksWrap.appendChild(taskRow(task)); }
      catch (e) { toast(e.message, 'err'); }
    };
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') add(); });
    panel.appendChild(addRow);
    return panel;
  }

  function taskRow(t) {
    const row = el('div', { class: 'task' + (t.done ? ' done' : '') });
    const chk = el('div', { class: 'chk' + (t.done ? ' on' : ''), html: t.done ? icon('check', 12) : '' });
    chk.addEventListener('click', async () => {
      t.done = !t.done; row.classList.toggle('done', t.done); chk.classList.toggle('on', t.done);
      chk.innerHTML = t.done ? icon('check', 12) : '';
      try { await Tasks.update(t.id, { done: t.done }); } catch (e) { toast(e.message, 'err'); }
    });
    const title = el('div', { class: 'tt', contenteditable: 'true' }, t.title);
    title.addEventListener('blur', () => { const v = title.textContent.trim(); if (v && v !== t.title) { t.title = v; Tasks.update(t.id, { title: v }).catch(() => {}); } });
    title.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); title.blur(); } });
    if (t.due) title.appendChild(el('div', { class: 'due' }, new Date(t.due).toLocaleDateString('fr-FR')));
    const del = el('button', { class: 'btn btn-sm btn-icon btn-ghost', html: icon('x', 14), title: 'Supprimer', style: { opacity: 0.6 } });
    del.addEventListener('click', async () => { try { await Tasks.remove(t.id); row.remove(); } catch (e) { toast(e.message, 'err'); } });
    row.append(chk, title, del);
    return row;
  }

  load();
}
